if (!customElements.get('frequently-bought')) {
  class FrequentlyBought extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.checkboxes = this.querySelectorAll('.custom-checkbox input');
      this.total = document.querySelector('.product__frequently--content .price-item');
      this.price = 0;
      this.currency = this.total.getAttribute('data-currency');
      this.button = document.querySelector('.product__frequently--content .button');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', this.updatePrice.bind(this));
      });

      this.button.addEventListener('click', this.addToCartBundle.bind(this));
      
      document.addEventListener('productChange', (e) => {
        const id = this.closest('.shopify-section.section').id.replace('shopify-section-', '');
        
        fetch(`${window.location.pathname}?variant=${e.detail}&section_id=${id}`)
          .then(res => res.text())
          .then(res => {
              let html = new DOMParser()
              .parseFromString(res, 'text/html')
              .querySelector('.shopify-section');
              
              if (document.querySelector(`[id*="${id}"]`)) {
                document.querySelector(`[id*="${id}"]`).innerHTML = html.innerHTML;
              }
          })
          .catch(error => {
            console.log(error);
          });
      });
    }

    updatePrice() {
      const checkedInput = this.querySelectorAll('.custom-checkbox input:checked');
        checkedInput.forEach(input => {
          const price = parseInt(input.getAttribute('data-price'));
          this.price = this.price + price;
        })
        this.total.innerHTML = this.adaptCurrency(this.price / 100);
        this.price = 0;

        this.updateButtonText(checkedInput.length, checkedInput);
    }

    updateButtonText(amount, singleInput) {
      if (amount >= 2 ) {
        this.button.querySelector('span').innerHTML = window.variantStrings.addToCartBundle.replace(
          '[number]',
          amount
        );
      }

      if (amount == 1) {
        const inputTitle = singleInput[0].getAttribute('data-title');
        this.button.querySelector('span').innerHTML = window.variantStrings.addToCartBundleSingle.replace(
          '[title]',
          inputTitle
        )
      }
    }

    adaptCurrency(price) {
      if (this.currency == 'EUR') {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR'
        }).format(price);
      }

      if (this.currency == 'USD') {
        return new Intl.NumberFormat('en-DE', {
          style: 'currency',
          currency: 'USD',
          maximumSignificantDigits: 4
        }).format(price);
      }
    }

    addToCartBundle() {
      this.button.setAttribute('aria-disabled', true);
      this.button.setAttribute('disabled', true);
      this.button.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      
      this.querySelector('.product-form__error-message-wrapper')?.remove();
      
      let body = [];

      this.checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          body.push({ quantity: 1, id: parseInt(checkbox.value)})
        }
      });

      const data = {
        items: body,
        sections: [
          'cart-notification-product', 
          'cart-notification-button', 
          'cart-icon-bubble'
        ]
      }

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
      .then((response) => response.json())
      .then((response) => {
        if (!response.status) {
          if (this.cart) {
            this.cart.renderContents(response);
          }
        } else {
          this.button.insertAdjacentHTML('afterend', `<div class="product-form__error-message-wrapper" role="alert">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
              <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
              <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
              <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
              <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
            </path></svg>
            <span class="product-form__error-message">${response.description}</span>
          </div>`);
        }
        this.button.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        this.button.removeAttribute('disabled');
        this.button.removeAttribute('aria-disabled');
      })
      .catch(error => console.error('Error Adding', error));
    }
  }

  customElements.define('frequently-bought', FrequentlyBought);
}
